import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'datetimeToString',
    pure: false
})
export class DatetimeToString implements PipeTransform {
    transform(date: any, args?: any): any {
        if(!date)
            return '';

        if(date?.indexOf('T') == -1)
            date = date.replace(' ','T')+'Z';

        let d = new Date(date);
        return d.toLocaleDateString('pt-BR',{hour:'numeric',minute:'numeric'});
   
    }
}